import { Phone, ShieldCheck, Camera, Clock } from "lucide-react";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import QuoteForm from "@/components/QuoteForm";
import { SITE } from "@/data/site";

export default function RequestQuote() {
  return (
    <>
      <Seo
        title="Request a Quote"
        description="Request a free electrical or CCTV quote from Kensmarc Electric. Tell us about your project, add photos, and choose a preferred date — we'll follow up with next steps."
        path="/request-a-quote"
      />
      <PageHeader
        eyebrow="Get Started"
        title="Request a quote"
        subtitle="Tell us about your electrical or security project. Add photos and a preferred date if you'd like — Marcos will review your request and reach out with next steps."
      />

      <section className="section-pad">
        <div className="container-kx grid gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:items-start">
          <div className="order-2 lg:order-1">
            <QuoteForm />
          </div>

          <aside className="order-1 space-y-5 lg:order-2 lg:sticky lg:top-24">
            <div className="rounded-2xl border border-[#22222c] bg-[#101017] p-6">
              <h2 className="font-display text-lg font-bold uppercase text-white">How it works</h2>
              <ol className="mt-4 space-y-4">
                {[
                  "Tell us about your project and add any photos.",
                  "Optionally choose a preferred date and time.",
                  "Marcos reviews your request and reaches out.",
                  "We confirm details and provide your quote.",
                ].map((step, i) => (
                  <li key={i} className="flex gap-3">
                    <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-amber-400 text-sm font-bold text-[#0A0A0C]">{i + 1}</span>
                    <span className="text-sm text-neutral-300">{step}</span>
                  </li>
                ))}
              </ol>
              <p className="mt-5 flex items-start gap-2 rounded-lg bg-amber-400/5 p-3 text-xs text-neutral-400">
                <Clock className="mt-0.5 h-4 w-4 shrink-0 text-amber-400" />
                Submitting is a request only — no appointment is confirmed until Kensmarc Electric contacts you.
              </p>
            </div>

            <div className="rounded-2xl border border-[#22222c] bg-[#101017] p-6">
              <p className="text-sm text-neutral-400">Prefer to talk?</p>
              <a href={SITE.phonePrimary.tel} data-testid="quote-page-call-primary" className="mt-2 flex items-center gap-2 text-lg font-semibold text-white hover:text-amber-400">
                <Phone className="h-5 w-5 text-amber-400" /> {SITE.phonePrimary.display}
              </a>
              <a href={SITE.phoneSecondary.tel} data-testid="quote-page-call-secondary" className="mt-1 flex items-center gap-2 text-sm text-neutral-300 hover:text-amber-400">
                <Phone className="h-4 w-4 text-amber-400" /> {SITE.phoneSecondary.display}
              </a>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-xl border border-[#22222c] bg-[#101017] p-4 text-center">
                <ShieldCheck className="mx-auto h-6 w-6 text-amber-400" />
                <p className="mt-2 text-xs font-semibold text-white">C-10 Licensed</p>
              </div>
              <div className="rounded-xl border border-[#22222c] bg-[#101017] p-4 text-center">
                <Camera className="mx-auto h-6 w-6 text-amber-400" />
                <p className="mt-2 text-xs font-semibold text-white">Electrical & CCTV</p>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </>
  );
}
